import { render, staticRenderFns } from "./Waveform.vue?vue&type=template&id=52efc381&scoped=true"
import script from "./Waveform.vue?vue&type=script&lang=js"
export * from "./Waveform.vue?vue&type=script&lang=js"
import style0 from "./Waveform.vue?vue&type=style&index=0&id=52efc381&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52efc381",
  null
  
)

export default component.exports